import {pageInfo, editData} from './../api';
import { Message } from 'element-ui';
import {companyListData} from "../../company/api";
import {listOrigin} from "../../../../api";
const yzCompany = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    editDataObj: null,
    originObj: null,
    companyObj: null
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = data.obj || [];
    },
    LIST_ORIGIN(state, data) {
      state.originObj = data.obj || {};
    },
    EDIT_DATA(state, data) {
      state.editDataObj = data;
    },
    LIST_COMPANY(state,data){
      state.companyObj = data.obj;;
    }
  },
  actions: {
    //查询事件
    async pageInfo({ commit }, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //发货方
    async listOrigin({ commit }, obj) {
      let resp = await listOrigin(obj);
      commit('LIST_ORIGIN', resp);
    },
    //修改保存事件
    async editData({ commit }, obj) {
      let resp = await editData(obj);
      commit('EDIT_DATA', resp);
    },
    //机构
    async listCompany({ commit }, obj) {
      let resp = await companyListData(obj);
      commit('LIST_COMPANY', resp);
    },
  }
}
export default yzCompany



// WEBPACK FOOTER //
// ./src/page/mdm/yzCompany/store/yzCompany.store.js